import React, { useEffect } from 'react';

import './App.css';

import { Routes, Route, BrowserRouter,Navigate } from 'react-router-dom';

import * as routes from './shared/routes';

import ResponsiveContainer  from './features/layout/ResponsiveContainer'


import Analyze from './features/components/Home'
import AnalyzeAndSign from './features/components/AnalyzeAndSign'
import Authenticode from './features/components/Authenticode'
import Imprint from './features/components/Imprint'
import { useTranslation } from 'react-i18next';



const App: React.FC = () => {
  const { t} = useTranslation();
  

  useEffect(() =>{
    document.title=t("main.title");
  },[t])

   return <BrowserRouter>
        <ResponsiveContainer>
          <Routes>
            <Route path={routes.HOME} element={<Analyze />} />
            <Route path={routes.SIGN} element={< AnalyzeAndSign />} />
            <Route path={routes.AUTHENTICODE} element={<Authenticode />} />
            <Route path={routes.IMPRINT} element={<Imprint />} />
            <Route path="/" element={<Navigate to={routes.HOME} />} />
          </Routes>
        </ResponsiveContainer>
       
      </BrowserRouter>
      
      
}
export default App;
